import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaContratados from '../../components/contratos/contratados';


function ListaContratadosScreen() {
    return (
        <Fragment>
            <Head titulo="Contratados e/ou Licitantes Sancionados Administrativamente" />
            <Header />
            <Container>
                <ListaContratados />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratadosScreen;